import { useDispatch } from "react-redux";
import { logout } from "../../slices/authSlice";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { tokenManager } from "services/client/token-manager";

/**
 * Custom hook for handling user logout
 * Clears authentication tokens, cookies, localStorage, and redirects to login page
 * @returns {Function} handleLogout - Function to execute logout
 */
const useLogoutSession = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    tokenManager.clearAll();
    Cookies.remove("accountDetails");
    dispatch(logout());
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("roles");
    localStorage.removeItem("searchBarKeyStorage"); // clear all persisted searchBarKeys
    // window.location.href = "/login";
    navigate("/login");
  };

  return handleLogout;
};

export default useLogoutSession;
